import {BASE_URL} from "@/constants/config";
import {request} from "@/utils/request";

export const COMPETENCE_ENDPOINTS = {
  base: `${BASE_URL}api/competences/`,
  template: `${BASE_URL}api/competences/template/`,
  export: `${BASE_URL}api/competences/export/`,
  competence: (id) => `${BASE_URL}api/competences/${id}/`,
};

class Competence {
  async createCompetence(payload){
    return await request({
      url: COMPETENCE_ENDPOINTS.base,
      method: "POST",
      body: payload,
    });
  }

  async updateCompetence(id, payload){
    return await request({
      url: COMPETENCE_ENDPOINTS.competence(id),
      method: "PATCH",
      body: payload,
    });
  }

  async blockCompetences(id){
    return await request({
      url: COMPETENCE_ENDPOINTS.base,
      body: id,
      method: "DELETE",
    });
  }
}

export const CompetenceService = new Competence();
